import { logger as LOG, logger } from '@garnish/logger';
import { compareDesc, parseISO } from 'date-fns';
import { uniqBy } from 'lodash';

import { type OrderWithIdAndWantedTime } from './orders-machine.types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * A tiny utility that removes potential duplicates from the order list,
 * which can occur if the user loads more orders with a delay.
 */
export function withoutDuplicateOrders<Order extends OrderWithIdAndWantedTime>(
  orders: Order[],
): Order[] {
  return uniqBy(orders, 'id');
}

/**
 * A utility for sorting order lists based on the wanted time of the orders.
 */
export function sortOrdersByWantedTime<Order extends OrderWithIdAndWantedTime>(
  orders: Order[],
): Order[] {
  return [...orders].sort((currentOrder, nextOrder) =>
    compareDesc(
      parseISO(currentOrder.wantedTime),
      parseISO(nextOrder.wantedTime),
    ),
  );
}

// ─── Logger ──────────────────────────────────────────────────────────────────

LOG.enable('REORDER ORDERS STATE MACHINE');

export const ordersMachineLogger = logger.extend(
  'REORDER ORDERS STATE MACHINE',
);
